import CardClass from "../../../CardClass";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid2";

export default class CardAdminModifierCodeGeneral extends CardClass {
  /**
   * Render the content of the card.
   */
  renderContent() {
    return (
      <MUIGrid container spacing={2}>
        <MUIGrid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <MUITextField
            value={this.props.modifierCode ? this.props.modifierCode.code : ""}
            autoFocus={true}
            size="small"
            label="Code"
            variant="standard"
            fullWidth={true}
            onBlur={(e) => this.props.onChange({ code: e.target.value.trim() })}
            onChange={(e) => this.props.onChange({ code: e.target.value })}
            required={true}
            error={this.props.validationIssues.code ? true : false}
            helperText={
              this.props.validationIssues.code
                ? this.props.validationIssues.code
                : ""
            }
            slotProps={{
              htmlInput: {
                maxLength: 2,
              },

              inputLabel: { shrink: true },
            }}
          />
        </MUIGrid>
        <MUIGrid
          size={{
            xs: 12,
            sm: 6,
            md: 8,
          }}
        >
          <MUITextField
            value={
              this.props.modifierCode ? this.props.modifierCode.description : ""
            }
            size="small"
            label="Description"
            variant="standard"
            fullWidth={true}
            onBlur={(e) =>
              this.props.onChange({ description: e.target.value.trim() })
            }
            onChange={(e) =>
              this.props.onChange({ description: e.target.value })
            }
            required={true}
            error={this.props.validationIssues.description ? true : false}
            helperText={
              this.props.validationIssues.description
                ? this.props.validationIssues.description
                : ""
            }
            slotProps={{
              htmlInput: {
                maxLength: 255,
              },

              inputLabel: { shrink: true },
            }}
          />
        </MUIGrid>
      </MUIGrid>
    );
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "General";
  }
}
